// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/infographic-page/infographic-page.component.scss
// module id = 488
// module chunks = 0